import React from "react";

export const PtLogo = ({ color }) => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 2C3 0.9 3.9 0 5 0C6.1 0 7 0.9 7 2C7 3.1 6.1 4 5 4C3.9 4 3 3.1 3 2ZM12 18C11.44 18 10.98 17.56 10.95 17L10.5 8L7 7H1C0.45 7 0 6.55 0 6C0 5.45 0.45 5 1 5H6L12.26 0.53C12.68 0.23 13.26 0.3 13.6 0.69C13.98 1.14 13.9 1.81 13.42 2.15L10.14 4.5H13L20.09 0.41C20.5 0.17 21.02 0.26 21.33 0.62C21.69 1.05 21.63 1.69 21.19 2.03L13.5 8L13.05 17C13.02 17.56 12.56 18 12 18Z"
        fill={color}
      />
    </svg>
  );
};
export const NotificationLogo = ({ color }) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          fill-rule="evenodd"
          clipRule="evenodd"
          d="M7.07046 10.26C7.96453 7.86801 9.19303 7.03601 11.2132 7.03601C13.2334 7.03601 14.4619 7.86801 15.356 10.26C15.3728 10.3055 15.3862 10.3524 15.396 10.4L16.5543 15.917C16.6155 16.2008 16.5485 16.4978 16.3719 16.7251C16.1953 16.9525 15.928 17.0858 15.6446 17.088H13.3173C13.37 17.6989 13.1737 18.3048 12.7751 18.7618C12.3764 19.2188 11.811 19.4861 11.2132 19.5C10.6151 19.4861 10.0494 19.2186 9.65063 18.7611C9.25191 18.3037 9.05587 17.6972 9.10918 17.086H6.78186C6.49847 17.0838 6.2312 16.9505 6.0546 16.7231C5.878 16.4958 5.81096 16.1988 5.87218 15.915L7.03048 10.4C7.04027 10.3524 7.05363 10.3055 7.07046 10.26Z"
          stroke="#4D4467"
          stroke-width="1.5"
          stroke-linejoin="round"
        ></path>{" "}
        <path
          d="M9.10921 16.336C8.69499 16.336 8.35921 16.6718 8.35921 17.086C8.35921 17.5002 8.69499 17.836 9.10921 17.836V16.336ZM13.3173 17.836C13.7315 17.836 14.0673 17.5002 14.0673 17.086C14.0673 16.6718 13.7315 16.336 13.3173 16.336V17.836ZM9.62888 4.75C9.21467 4.75 8.87888 5.08579 8.87888 5.5C8.87888 5.91421 9.21467 6.25 9.62888 6.25V4.75ZM12.7976 6.25C13.2118 6.25 13.5476 5.91421 13.5476 5.5C13.5476 5.08579 13.2118 4.75 12.7976 4.75V6.25ZM9.10921 17.836H13.3173V16.336H9.10921V17.836ZM9.62888 6.25H12.7976V4.75H9.62888V6.25Z"
          fill="#4D4467"
        ></path>{" "}
      </g>
    </svg>
  );
};
export const SuccessLogo = ({ color }) => {
  return (
    <>
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        width="75px"
        height="75px"
        fill="#000000"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0" />

        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <circle style={{ fill: "#25AE88" }} cx="25" cy="25" r="25" />{" "}
          <polyline
            style={{
              fill: "none",
              stroke: "#FFFFFF",
              strokeWidth: 2,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 10,
            }}
            points=" 38,15 22,33 12,25 "
          />{" "}
        </g>
      </svg>
    </>
  );
};

export const ClassesLogo = ({ color }) => {
  return (
    <svg
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6.75C13.63 6.75 15.07 7.14 16.24 7.65C17.32 8.13 18 9.21 18 10.38V11C18 11.55 17.55 12 17 12H7C6.45 12 6 11.55 6 11V10.39C6 9.21 6.68 8.13 7.76 7.66C8.93 7.14 10.37 6.75 12 6.75ZM4 7C5.1 7 6 6.1 6 5C6 3.9 5.1 3 4 3C2.9 3 2 3.9 2 5C2 6.1 2.9 7 4 7ZM5.13 8.1C4.76 8.04 4.39 8 4 8C3.01 8 2.07 8.21 1.22 8.58C0.48 8.9 0 9.62 0 10.43V11C0 11.55 0.45 12 1 12H4.5V10.39C4.5 9.56 4.73 8.78 5.13 8.1ZM20 7C21.1 7 22 6.1 22 5C22 3.9 21.1 3 20 3C18.9 3 18 3.9 18 5C18 6.1 18.9 7 20 7ZM24 10.43C24 9.62 23.52 8.9 22.78 8.58C21.93 8.21 20.99 8 20 8C19.61 8 19.24 8.04 18.87 8.1C19.27 8.78 19.5 9.56 19.5 10.39V12H23C23.55 12 24 11.55 24 11V10.43ZM12 0C13.66 0 15 1.34 15 3C15 4.66 13.66 6 12 6C10.34 6 9 4.66 9 3C9 1.34 10.34 0 12 0Z"
        fill={color}
      />
    </svg>
  );
};

export const RetailLogo = ({ color }) => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M4 6v12h16.001L20 6H4zm4 10H6V8h2v8zm2 0H9V8h1v8zm2 0h-1V8h1v8zm4 0h-3V8h3v8zm2 0h-1V8h1v8z"
      />
      <path
        d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.001 12H4z"
        fill={color}
      />
      <path
        d="M6 8h2v8H6zm3 0h1v8H9zm8 0h1v8h-1zm-4 0h3v8h-3zm-2 0h1v8h-1z"
        fill={color}
      />
    </svg>
  );
};

export const StaffLogo = ({ color }) => {
  return (
    <svg
      width="22"
      height="14"
      viewBox="0 0 22 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 6C16.66 6 17.99 4.66 17.99 3C17.99 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 4.66 13.34 6 15 6ZM7 6C8.66 6 9.99 4.66 9.99 3C9.99 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3C4 4.66 5.34 6 7 6ZM7 8C4.67 8 0 9.17 0 11.5V13C0 13.55 0.45 14 1 14H13C13.55 14 14 13.55 14 13V11.5C14 9.17 9.33 8 7 8ZM15 8C14.71 8 14.38 8.02 14.03 8.05C14.05 8.06 14.06 8.08 14.07 8.09C15.21 8.92 16 10.03 16 11.5V13C16 13.35 15.93 13.69 15.82 14H21C21.55 14 22 13.55 22 13V11.5C22 9.17 17.33 8 15 8Z"
        fill={color}
      />
    </svg>
  );
};
export const TransactionLogo = ({ color }) => {
  return (
    <svg
      fill={color}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      width="30"
      height="25"
      viewBox="0 0 30 30"
      // xml:space="preserve"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="5"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <g id="money_8">
            {" "}
            <g>
              {" "}
              <path d="M10.715,10.416H6.727v4.055v2.742v4.047h3.988h10.416h4.043v-4.045v-2.748v-4.051h-4.043H10.715z M10.584,20.135 c-0.355-1.344-1.398-2.398-2.732-2.773v-3.038c1.336-0.377,2.381-1.438,2.734-2.783h3.156c-1.471,0.848-2.463,2.434-2.463,4.248 c0,1.89,1.074,3.529,2.643,4.347H10.584L10.584,20.135z M17.621,17.133c-0.061,0.131-0.145,0.246-0.25,0.346 c-0.107,0.098-0.232,0.178-0.379,0.24c-0.146,0.059-0.307,0.096-0.477,0.105v0.357h-0.801v-0.467 c-0.043-0.021-0.082-0.037-0.123-0.055c-0.041-0.02-0.078-0.037-0.117-0.055v0.176h-0.799v-1.197h0.799 c0.068,0.076,0.137,0.141,0.203,0.197c0.066,0.055,0.135,0.1,0.205,0.137c0.07,0.035,0.148,0.063,0.234,0.08 c0.086,0.018,0.184,0.025,0.293,0.025c0.146,0,0.264-0.029,0.357-0.088c0.096-0.06,0.145-0.137,0.145-0.232 c0-0.08-0.023-0.148-0.074-0.209c-0.049-0.059-0.111-0.107-0.189-0.15c-0.076-0.041-0.164-0.073-0.256-0.1 c-0.095-0.025-0.187-0.045-0.277-0.059c-0.322-0.051-0.582-0.125-0.775-0.229c-0.193-0.104-0.342-0.215-0.447-0.338 c-0.105-0.121-0.174-0.246-0.205-0.373c-0.033-0.127-0.049-0.24-0.049-0.34c0-0.145,0.027-0.279,0.08-0.41 c0.053-0.129,0.129-0.244,0.225-0.344c0.098-0.102,0.211-0.186,0.344-0.252c0.131-0.066,0.273-0.111,0.43-0.135v-0.375h0.8v0.432 c0.116,0.035,0.226,0.08,0.317,0.139v-0.172h0.799v1.197h-0.805c-0.063-0.072-0.127-0.135-0.188-0.191 c-0.061-0.055-0.125-0.1-0.191-0.135c-0.068-0.037-0.145-0.064-0.225-0.084c-0.084-0.02-0.181-0.027-0.29-0.027 c-0.16,0-0.283,0.037-0.369,0.113c-0.084,0.074-0.127,0.156-0.127,0.244c0,0.248,0.266,0.41,0.799,0.492 c0.33,0.049,0.594,0.129,0.789,0.242c0.195,0.111,0.347,0.232,0.447,0.365c0.104,0.129,0.168,0.26,0.196,0.387 c0.029,0.127,0.043,0.23,0.043,0.312C17.713,16.859,17.684,17,17.621,17.133z M24.049,14.338v3.007 c-1.357,0.358-2.426,1.429-2.787,2.787H18.43c1.568-0.815,2.645-2.457,2.645-4.347c0-1.814-0.992-3.4-2.465-4.248h2.65 C21.619,12.904,22.688,13.974,24.049,14.338z"></path>{" "}
              <path d="M32,2.949l-8.703-2.137L22.83,9.8l2.557-1.893c0,0,3.334,3.498,1.07,9.838c7.904-7,3.264-13.107,3.264-13.107L32,2.949z"></path>{" "}
              <path d="M5.543,14.25c-7.902,7-3.264,13.109-3.264,13.109L0,29.051l8.705,2.137l0.465-8.99L6.615,24.09 C6.615,24.09,3.279,20.594,5.543,14.25z"></path>{" "}
            </g>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export const RevenueLogo = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11.41 16.09V16.67C11.41 17.4 10.81 18 10.08 18H10.07C9.34 18 8.74 17.4 8.74 16.67V16.07C7.41 15.79 6.23 15.06 5.73 13.83C5.5 13.28 5.93 12.67 6.53 12.67H6.77C7.14 12.67 7.44 12.92 7.58 13.27C7.87 14.02 8.63 14.54 10.09 14.54C12.05 14.54 12.49 13.56 12.49 12.95C12.49 12.12 12.05 11.34 9.82 10.81C7.34 10.21 5.64 9.19 5.64 7.14C5.64 5.42 7.03 4.3 8.75 3.93V3.33C8.75 2.6 9.35 2 10.08 2H10.09C10.82 2 11.42 2.6 11.42 3.33V3.95C12.8 4.29 13.67 5.15 14.05 6.21C14.25 6.76 13.83 7.34 13.24 7.34H12.98C12.61 7.34 12.31 7.08 12.21 6.72C11.98 5.96 11.35 5.47 10.09 5.47C8.59 5.47 7.69 6.15 7.69 7.11C7.69 7.95 8.34 8.5 10.36 9.02C12.38 9.54 14.54 10.41 14.54 12.93C14.52 14.76 13.15 15.76 11.41 16.09Z"
        fill={color}
      />
    </svg>
  );
};

export const WalletLogo = ({ color }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 13V5C7 3.9 7.89 3 9 3H18V2C18 0.9 17.1 0 16 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V15H9C7.89 15 7 14.1 7 13ZM10 5C9.45 5 9 5.45 9 6V12C9 12.55 9.45 13 10 13H19V5H10ZM13 10.5C12.17 10.5 11.5 9.83 11.5 9C11.5 8.17 12.17 7.5 13 7.5C13.83 7.5 14.5 8.17 14.5 9C14.5 9.83 13.83 10.5 13 10.5Z"
        fill={color}
      />
    </svg>
  );
};

export const CalendarLogo = ({ color, width = "18", height = "20" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 11H10C9.45 11 9 11.45 9 12V15C9 15.55 9.45 16 10 16H13C13.55 16 14 15.55 14 15V12C14 11.45 13.55 11 13 11ZM13 1V2H5V1C5 0.45 4.55 0 4 0C3.45 0 3 0.45 3 1V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2H15V1C15 0.45 14.55 0 14 0C13.45 0 13 0.45 13 1ZM15 18H3C2.45 18 2 17.55 2 17V7H16V17C16 17.55 15.55 18 15 18Z"
        fill={color}
      />
    </svg>
  );
};

export const AnalyticsLogo = ({ color }) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 18H1C0.45 18 0 17.55 0 17V7C0 6.45 0.45 6 1 6H4.5C5.05 6 5.5 6.45 5.5 7V17C5.5 17.55 5.05 18 4.5 18ZM11.75 0H8.25C7.7 0 7.25 0.45 7.25 1V17C7.25 17.55 7.7 18 8.25 18H11.75C12.3 18 12.75 17.55 12.75 17V1C12.75 0.45 12.3 0 11.75 0ZM19 8H15.5C14.95 8 14.5 8.45 14.5 9V17C14.5 17.55 14.95 18 15.5 18H19C19.55 18 20 17.55 20 17V9C20 8.45 19.55 8 19 8Z"
        fill={color}
      />
    </svg>
  );
};
export const RetentionLogo = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 0H2C1 0 0 0.9 0 2V5.01C0 5.73 0.43 6.35 1 6.7V18C1 19.1 2.1 20 3 20H17C17.9 20 19 19.1 19 18V6.7C19.57 6.35 20 5.73 20 5.01V2C20 0.9 19 0 18 0ZM12 12H8C7.45 12 7 11.55 7 11C7 10.45 7.45 10 8 10H12C12.55 10 13 10.45 13 11C13 11.55 12.55 12 12 12ZM18 5H2V2H18V5Z"
        fill={color}
      />
    </svg>
  );
};
export const InvoiceLogo = ({ color, onClickFunction }) => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClickFunction}
    >
      <path
        d="M18 0.210195C17.87 0.210195 17.74 0.260195 17.65 0.360195L16.86 1.1502C16.66 1.3502 16.35 1.3502 16.15 1.1502L15.36 0.360195C15.16 0.160195 14.85 0.160195 14.65 0.360195L13.86 1.1502C13.66 1.3502 13.35 1.3502 13.15 1.1502L12.36 0.360195C12.16 0.160195 11.85 0.160195 11.65 0.360195L10.86 1.1502C10.66 1.3502 10.35 1.3502 10.15 1.1502L9.36 0.360195C9.16 0.160195 8.85 0.160195 8.65 0.360195L7.86 1.1502C7.66 1.3502 7.35 1.3502 7.15 1.1502L6.35 0.350195C6.15 0.150195 5.84 0.150195 5.64 0.350195L4.85 1.1502C4.65 1.3502 4.34 1.3502 4.14 1.1502L3.35 0.350195C3.15 0.150195 2.84 0.150195 2.64 0.350195L1.85 1.1502C1.65 1.3502 1.34 1.3502 1.14 1.1502L0.35 0.350195C0.26 0.260195 0.13 0.210195 0 0.210195V19.8002C0.13 19.8002 0.26 19.7502 0.35 19.6502L1.14 18.8602C1.34 18.6602 1.65 18.6602 1.85 18.8602L2.64 19.6502C2.84 19.8502 3.15 19.8502 3.35 19.6502L4.14 18.8602C4.34 18.6602 4.65 18.6602 4.85 18.8602L5.64 19.6502C5.84 19.8502 6.15 19.8502 6.35 19.6502L7.14 18.8602C7.34 18.6602 7.65 18.6602 7.85 18.8602L8.64 19.6502C8.84 19.8502 9.15 19.8502 9.35 19.6502L10.14 18.8602C10.34 18.6602 10.65 18.6602 10.85 18.8602L11.64 19.6502C11.84 19.8502 12.15 19.8502 12.35 19.6502L13.14 18.8602C13.34 18.6602 13.65 18.6602 13.85 18.8602L14.64 19.6502C14.84 19.8502 15.15 19.8502 15.35 19.6502L16.14 18.8602C16.34 18.6602 16.65 18.6602 16.85 18.8602L17.64 19.6502C17.74 19.7502 17.87 19.8002 17.99 19.8002V0.210195H18ZM14 15.0002H4C3.45 15.0002 3 14.5502 3 14.0002C3 13.4502 3.45 13.0002 4 13.0002H14C14.55 13.0002 15 13.4502 15 14.0002C15 14.5502 14.55 15.0002 14 15.0002ZM14 11.0002H4C3.45 11.0002 3 10.5502 3 10.0002C3 9.4502 3.45 9.0002 4 9.0002H14C14.55 9.0002 15 9.4502 15 10.0002C15 10.5502 14.55 11.0002 14 11.0002ZM14 7.0002H4C3.45 7.0002 3 6.5502 3 6.0002C3 5.4502 3.45 5.0002 4 5.0002H14C14.55 5.0002 15 5.4502 15 6.0002C15 6.5502 14.55 7.0002 14 7.0002Z"
        fill={color}
      />
    </svg>
  );
};
export const FiltersLogo = ({ color }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.625 13.75C0.625 14.2312 1.01875 14.625 1.5 14.625H5.875V12.875H1.5C1.01875 12.875 0.625 13.2688 0.625 13.75ZM0.625 3.25C0.625 3.73125 1.01875 4.125 1.5 4.125H9.375V2.375H1.5C1.01875 2.375 0.625 2.76875 0.625 3.25ZM9.375 15.5V14.625H15.5C15.9812 14.625 16.375 14.2312 16.375 13.75C16.375 13.2688 15.9812 12.875 15.5 12.875H9.375V12C9.375 11.5188 8.98125 11.125 8.5 11.125C8.01875 11.125 7.625 11.5188 7.625 12V15.5C7.625 15.9812 8.01875 16.375 8.5 16.375C8.98125 16.375 9.375 15.9812 9.375 15.5ZM4.125 6.75V7.625H1.5C1.01875 7.625 0.625 8.01875 0.625 8.5C0.625 8.98125 1.01875 9.375 1.5 9.375H4.125V10.25C4.125 10.7312 4.51875 11.125 5 11.125C5.48125 11.125 5.875 10.7312 5.875 10.25V6.75C5.875 6.26875 5.48125 5.875 5 5.875C4.51875 5.875 4.125 6.26875 4.125 6.75ZM16.375 8.5C16.375 8.01875 15.9812 7.625 15.5 7.625H7.625V9.375H15.5C15.9812 9.375 16.375 8.98125 16.375 8.5ZM12 5.875C12.4812 5.875 12.875 5.48125 12.875 5V4.125H15.5C15.9812 4.125 16.375 3.73125 16.375 3.25C16.375 2.76875 15.9812 2.375 15.5 2.375H12.875V1.5C12.875 1.01875 12.4812 0.625 12 0.625C11.5188 0.625 11.125 1.01875 11.125 1.5V5C11.125 5.48125 11.5188 5.875 12 5.875Z"
        fill={color}
      />
    </svg>
  );
};
